import type { UrlObject } from "node:url";
import {
	Calendar01Icon,
	DashboardSquare01Icon,
	Home09Icon,
	Location01Icon,
} from "@hugeicons/core-free-icons";
import type { IconSvgElement } from "@hugeicons/react";

export type NavItem = {
	key: string;
	label: string;
	href: UrlObject;
	pathname: string;
	icon: IconSvgElement;
	activePrefixes?: string[];
	showInHeader?: boolean;
	showInMobile?: boolean;
	hideOnDesktop?: boolean;
	roles?: string[];
	protected?: boolean;
};

export const NAVIGATION_ITEMS: NavItem[] = [
	{
		key: "home",
		label: "Home",
		href: { pathname: "/" },
		pathname: "/",
		icon: Home09Icon,
		activePrefixes: ["/"],
		showInHeader: false,
		showInMobile: false,
		hideOnDesktop: true,
		protected: false,
	},
	{
		key: "tournaments",
		label: "Tournaments",
		href: { pathname: "/tournaments" },
		pathname: "/tournaments",
		icon: Calendar01Icon,
		activePrefixes: ["/tournaments", "/events", "/e/", "/t/"],
		showInHeader: true,
		showInMobile: true,
		protected: false,
	},
	{
		key: "venues",
		label: "Venues",
		href: { pathname: "/venues" },
		pathname: "/venues",
		icon: Location01Icon,
		activePrefixes: ["/venues", "/v/"],
		showInHeader: true,
		showInMobile: true,
		protected: false,
	},
	{
		key: "dashboard",
		label: "Dashboard",
		href: { pathname: "/dashboard" },
		pathname: "/dashboard",
		icon: DashboardSquare01Icon,
		activePrefixes: ["/dashboard"],
		showInHeader: true,
		showInMobile: true,
		protected: true,
	},
];

export function isNavItemActive(pathname: string | null, item: NavItem) {
	if (!pathname) {
		return false;
	}

	const activePrefixes = item.activePrefixes ?? [item.pathname];

	return activePrefixes.some((prefix) =>
		prefix === "/"
			? pathname === "/"
			: pathname === prefix || pathname.startsWith(prefix),
	);
}
